<template>
  <div
    class="u-16 u-8-ss hor-padding-5 hor-padding-20-ss grid multicross-start"
  >
    <div class="u-16">
      <el-tabs :type="showCP ? 'card' : ''">
        <!-- Order info -->
        <el-tab-pane :label="title">
          <el-table
            :data="transactionInfo.info"
            :show-header="false"
            style="width: 100%"
            size="medium"
            stripe
          >
            <el-table-column width="300">
              <template slot-scope="scope">{{
                scope.row.field | fieldName
              }}</template>
            </el-table-column>
            <el-table-column>
              <template slot-scope="scope">
                <!-- Card tooltip -->
                <el-tooltip
                  v-if="scope.row.field == 'pan_mask'"
                  class="item"
                  effect="dark"
                  placement="top"
                  transition="el-zoom-in-bottom"
                  :open-delay="300"
                >
                  <div slot="content">{{ cardName(cardId) }}</div>
                  <span class="card-type" :class="cardClass(cardId)"></span>
                </el-tooltip>

                <!-- Apple Pay tooltip -->
                <el-tooltip
                  v-if="
                    scope.row.field == 'card_holder' &&
                    scope.row.data == 'APPLE PAY'
                  "
                  class="item"
                  effect="dark"
                  placement="top"
                  transition="el-zoom-in-bottom"
                  :open-delay="300"
                >
                  <div slot="content">Apple Pay</div>
                  <img class="apple-pay" :src="holderImg(scope.row.data)" />
                </el-tooltip>

                <!-- Processing icon -->
                <img
                  class="processing-icon"
                  v-if="scope.row.field == 'processing_id'"
                  :src="processingIcon(scope.row.data)"
                />

                <!-- IP flag -->
                <el-tooltip
                  v-if="
                    scope.row.field == 'ip' && imgSrc(scope.row.field) != ''
                  "
                  class="item"
                  effect="dark"
                  placement="top"
                  transition="el-zoom-in-bottom"
                  :open-delay="300"
                >
                  <div slot="content">
                    {{ countryNameRu(transactionInfo.ip_country_code) }}
                  </div>
                  <img class="flag-icon" :src="imgSrc(scope.row.field)" />
                </el-tooltip>

                <!-- Bank flag -->
                <el-tooltip
                  v-if="
                    scope.row.field == 'bank_name' &&
                    imgSrc(scope.row.field) != ''
                  "
                  class="item"
                  effect="dark"
                  placement="top"
                  transition="el-zoom-in-bottom"
                  :open-delay="300"
                >
                  <div slot="content">
                    {{ countryNameRu(transactionInfo.bank_country_code) }}
                  </div>
                  <img class="flag-icon" :src="imgSrc(scope.row.field)" />
                </el-tooltip>
                {{ showName(scope.row.field, scope.row.data) }}
              </template>
            </el-table-column>
          </el-table>
        </el-tab-pane>

        <!-- Custom params -->
        <el-tab-pane label="Параметры заказа" v-if="showCP">
          <el-table
            :data="sortOrderCP"
            style="width: 100%"
            :show-header="false"
            size="medium"
            class="customparams"
            stripe
          >
            <el-table-column prop="k" width="200"></el-table-column>
            <el-table-column prop="v"></el-table-column>
          </el-table>
        </el-tab-pane>

        <!-- Goods -->
        <el-tab-pane label="Товары" v-if="isReceipt">
          <el-table
            :data="orderGoods"
            style="width: 100%"
            :show-header="false"
            size="medium"
            class="goods"
            stripe
          >
            <el-table-column type="expand">
              <template slot-scope="props">
                <div class="grid">
                  <div class="u-3">Поставщик:</div>
                  <div>{{ getSupplierName(props.row.supplier) }}</div>
                </div>
                <div class="grid ver-margin-10">
                  <div class="u-3">Инн:</div>
                  <div>{{ getSupplierInn(props.row.supplier) }}</div>
                </div>
                <div class="grid">
                  <div class="u-3">Телефон:</div>
                  <div>{{ getSupplierPhone(props.row.supplier) }}</div>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="name"
              label="Наименование"
              width="250"
            ></el-table-column>
            <el-table-column label="Сумма">
              <template slot-scope="scope"
                >{{ scope.row.amount | amountFormat }}
                {{ currencyCharacter(scope.row.currency_code) }}</template
              >
            </el-table-column>
            <el-table-column label="Ставка">
              <template slot-scope="scope">{{
                scope.row.tax | taxName
              }}</template>
            </el-table-column>
            <el-table-column prop="payment_subject_type" label="Предмет">
              <template slot-scope="scope">{{
                scope.row.payment_subject_type | subjectName
              }}</template>
            </el-table-column>
          </el-table>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import vuex from "vuex";
import { _ } from "vue-underscore";
import { mapGetters } from "vuex";
import { apiUrl } from "@/api/apiUrl";
import goods from "@/localize/goods.js";

import moment from "moment";
import axios from "axios";
import order_info_fields from "../localize/localize.js";

export default {
  name: "OrderInfo",
  props: [
    "transactionInfo",
    "rowId",
    "orderCP",
    "orderGoods",
    "isReceipt",
    "title",
    "showCP",
    "merchantName",
    "cardId",
    "fullWidth",
  ],
  data() {
    return {
      isEmpty: false,
      isFullDetails: false,
    };
  },
  methods: {
    parseCP(cp) {
      let dataCP = [];
      if (cp != "") {
        let arrCP = cp.split(";");
        arrCP.forEach((item) => {
          if (item != "") {
            let CP = {
              field: item.split("=")[0],
              data: item.split("=")[1],
            };
            dataCP.push(CP);
          }
        });
      }
      return dataCP;
    },
    showName(field, value) {
      if (field == "merchant_id") value = this.merchantName;
      if (field == "processing_id") value = this.processingName(value);
      if (field == "antifraud_decision") value = this.decisionName(value);
      if (field == "terminal_id" || field == "split_terminal_id")
        value = this.terminalName(value);
      if (field == "card_holder" && value == "APPLE PAY") value = "";
      if (field == "amount")
        value = parseFloat(value / 100)
          .toFixed(2)
          .replace(/(\d)(?=(\d{3})+\.)/g, "$1 ");
      if (field == "is_recurrent" || field == "is_receipt")
        value = value ? "Да" : "Нет";
      if (field == "no_cvv") value = value ? "Да" : "Нет";
      if (field == "pan_mask") value = value.replace(/[*]/g, "x");
      if (field == "currency_code")
        value =
          this.currencyNameRu(value) +
          " (" +
          this.currencyCharacter(value) +
          ")";
      if (field == "bank_country_code" || field == "ip_country_code")
        value = this.countryNameRu(value);
      return value;
    },
    imgSrc(field) {
      const url = "https://static-stage.mapcard.pro/static/bo/images/flags/";
      if (field == "ip") {
        let ipCountryCode =
          this.transactionInfo["ip_country_code"] != ""
            ? this.transactionInfo["ip_country_code"]
            : "ZZ";
        return url + ipCountryCode.toLowerCase() + ".png";
      } else {
        let bankCountryCode =
          this.transactionInfo["bank_country_code"] != ""
            ? this.transactionInfo["bank_country_code"]
            : "ZZ";
        return url + bankCountryCode.toLowerCase() + ".png";
      }
    },
    getSupplierName(value) {
      if (value) {
        if (JSON.parse(value)["name"]) return JSON.parse(value)["name"]
        else return "—"
      }
      else return "—";
    },
    getSupplierInn(value) {
      if (value) {
        if (JSON.parse(value)["inn"]) return JSON.parse(value)["inn"]
        else return "—"
      }
      else return "—";
    },
    getSupplierPhone(value) {
      if (value) {
        if (JSON.parse(value)["phone_numbers"]) return JSON.parse(value)["phone_numbers"].join(", ")
        else return "—"
      }
      else return "—";
    },
  },
  filters: {
    fieldName(value) {
      return order_info_fields[value] || value;
    },
    taxName(id) {
      let res = goods.tax.find((el) => el.id == id).value
      if(res) return res;
      else return '';
    },
    subjectName(id) {
      let res = goods.subjectTypes.find((el) => el.id == id).value;
      if(res) return res;
      else return '';
    },
  },
  computed: {
    ...mapGetters([
      "processingName",
      "processingIcon",
      "terminalName",
      "cardClass",
      "cardName",
      "holderImg",
      "currencyNameRu",
      "currencyCharacter",
      "decisionName",
      "countryNameRu",
    ]),
    sortOrderCP() {
      return this.orderCP;
    },
  },
};
</script>

<style lang="sass">
.el-tabs__header
  margin: 0px
.el-tabs--card .el-tabs__content
  border: 1px solid #ededed
  border-width: 0px 1px 1px 1px
  table tr
    cursor: default
  .el-table__expanded-cell
    border-left: 48px solid #F6F9FC
    padding: 20px 15px
.el-tabs__item
  font-weight: 400
  &.is-active
    font-weight: 500
.goods.el-table .cell
  word-break: break-word
</style>